import { render, staticRenderFns } from "./CreateCompanyPage.vue?vue&type=template&id=589aa124&scoped=true"
import script from "./CreateCompanyPage.vue?vue&type=script&lang=js"
export * from "./CreateCompanyPage.vue?vue&type=script&lang=js"
import style0 from "./CreateCompanyPage.vue?vue&type=style&index=0&id=589aa124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589aa124",
  null
  
)

export default component.exports